export default __webpack_public_path__ + "static/media/power_of_attorney_page.9b1a8390.pdf";